import {
  SUBMIT_OFFER_FAIL,
  SUBMIT_OFFER_SUCCESS,
  REQUEST_ACCESS_SUCCESS,
  REQUEST_ACCESS_FAIL,
  GET_CAREPROVIDERS,
  LOGOUT_USER,
  ONGOING_REQUEST,
  GET_CAREPROVIDER_PATIENTS,
  GET_CAREPROVIDER_STAFF,
  GET_STAFF_CLIENT,
  GET_SUPPORTS,
  ONGOING_REQUEST_DEVICE,
  ONGOING_PM_SESSION_REQUEST
} from "../actions/types";
import subType from "./readingSubType.json";

import readingType from "./readingType.json";
const INITIAL_STATE = {
  submitOfferFail: false,
  requestAccessFail: false,

  genericErrorMessage: "",
  isGenericError: false,
  isGenericSuccess: false,

  ongoingRequest: false,
  careproviders: [],
  supports: [],
  careproviderPatients: [],
  careproviderStaff: [],
  clientStaff: []
};

const RESET_STATE = {
  submitOfferFail: false,
  requestAccessFail: false,

  genericErrorMessage: "",
  isGenericError: false,
  isGenericSuccess: false,

  ongoingRequest: false,
  careproviders: [],
  supports: [],
  careproviderPatients: [],
  careproviderStaff: [],
  clientStaff: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGOUT_USER:
      return {
        ...state,
        ...RESET_STATE
      };
    case SUBMIT_OFFER_SUCCESS:
      return {
        ...state,
        isGenericError: false,
        isGenericSuccess: action.payload.isGenericSuccess,
        genericErrorMessage: ""
      };
    case ONGOING_REQUEST:
      return {
        ...state,
        ongoingRequest: action.payload
      };
    case ONGOING_REQUEST_DEVICE:
      return {
        ...state,
        ongoingRequestDevice: action.payload
      };
    case ONGOING_PM_SESSION_REQUEST:
      return {
        ...state,
        ongoingPmSessionRequest: action.payload
      };
    case SUBMIT_OFFER_FAIL:
      return {
        ...state,
        isGenericError: true,
        isGenericSuccess: false,
        genericErrorMessage: action.payload
      };
    case REQUEST_ACCESS_SUCCESS:
      return {
        ...state,
        isGenericError: false,
        isGenericSuccess: true,
        genericErrorMessage: ""
      };
    case REQUEST_ACCESS_FAIL:
      return {
        ...state,
        isGenericError: true,
        isGenericSuccess: false,
        genericErrorMessage: action.payload
      };
    case GET_CAREPROVIDERS:
      
      return {
        ...state,
        careproviders: action.payload.data
      };
    case GET_SUPPORTS:
      
      return {
        ...state,
        supports: action.payload.data
      };
    case GET_CAREPROVIDER_PATIENTS:
      
      return {
        ...state,
        careproviderPatients: action.payload.data
      };
    case GET_CAREPROVIDER_STAFF:
      
      return {
        ...state,
        careproviderStaff: action.payload.data
      };
    case GET_STAFF_CLIENT:
      
      return {
        ...state,
        clientStaff: action.payload.data
      };

    default:
      return state;
  }
};
